import { useEffect, useState } from 'react';
import { useQueryParams } from '../queryParams/useQueryParams';
import { loadViewState } from './viewState';

export const useLoadViewState = <
  StorageKey extends string = string,
  State extends Record<string, any> = Record<string, any>,
>(
  storageKey: StorageKey,
  defaults?: State,
) => {
  const [isQueryParamCleared, setIsQueryParamCleared] = useState(false);
  const [{ loadSavedState }, setQueryParams] = useQueryParams();

  const [state] = useState(() => {
    if (typeof loadSavedState !== 'undefined') {
      const savedState = loadViewState(storageKey);
      if (savedState) {
        return savedState;
      }
    }

    return { ...defaults };
  });

  useEffect(() => {
    if (typeof loadSavedState !== 'undefined') {
      setQueryParams({ loadSavedState: undefined }, { replace: true });
    } else {
      setIsQueryParamCleared(true);
    }
  }, [loadSavedState, setQueryParams]);

  return { state, isQueryParamCleared };
};
